const getSearchLink = () => {
  return '/search'
}

export { getSearchLink }
